function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
import { equalColorObjects as m } from "../utils/compare.js";
import { tpl as d, fire as u } from "../utils/dom.js";
import { Hue as p } from "./hue.js";
import { Saturation as f } from "./saturation.js";
import b from "../styles/color-picker.js";
import v from "../styles/hue.js";
import y from "../styles/saturation.js";
var r = Symbol("same"),
  l = Symbol("color"),
  c = Symbol("hsva"),
  i = Symbol("update"),
  a = Symbol("parts"),
  h = Symbol("css"),
  n = Symbol("sliders");
var k = /*#__PURE__*/function (_HTMLElement) {
  function k() {
    var _this;
    _classCallCheck(this, k);
    _this = _callSuper(this, k);
    var o = d("<style>".concat(_this[h].join(""), "</style>")),
      t = _this.attachShadow({
        mode: "open"
      });
    t.appendChild(o.content.cloneNode(!0)), t.addEventListener("move", _this), _this[a] = _this[n].map(function (s) {
      return new s(t);
    });
    return _this;
  }
  _inherits(k, _HTMLElement);
  return _createClass(k, [{
    key: h,
    get: function get() {
      return [b, v, y];
    }
  }, {
    key: n,
    get: function get() {
      return [f, p];
    }
  }, {
    key: "color",
    get: function get() {
      return this[l];
    },
    set: function set(o) {
      if (!this[r](o)) {
        var t = this.colorModel.toHsva(o);
        this[i](t), this[l] = o;
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      if (this.hasOwnProperty("color")) {
        var o = this.color;
        delete this.color, this.color = o;
      } else this.color || (this.color = this.colorModel.defaultColor);
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(o, t, s) {
      var e = this.colorModel.fromAttr(s);
      this[r](e) || (this.color = e);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(o) {
      var t = this[c],
        s = _objectSpread(_objectSpread({}, t), o.detail);
      this[i](s);
      var e;
      !m(s, t) && !this[r](e = this.colorModel.fromHsva(s)) && (this[l] = e, u(this, "color-changed", {
        value: e
      }));
    }
  }, {
    key: r,
    value: function value(o) {
      return this.color && this.colorModel.equal(o, this.color);
    }
  }, {
    key: i,
    value: function value(o) {
      this[c] = o, this[a].forEach(function (t) {
        return t.update(o);
      });
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["color"];
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
export { h as $css, n as $sliders, k as ColorPicker };